module.exports = __webpack_public_path__ + "img/bg5.5edc543a.jpg";